import watchUtils = require("esri/core/watchUtils");
import GroupLayer = require("esri/layers/GroupLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import BuildPopups from "./buildPopups";
import * as layerSource from "./layerSource";

export const illinoisCountiesArcadeExpressionInfos = [
  {
    name: "county-name",
    title: "County Name",
    expression: "Proper($feature.NAME_LC)"
  }
];

export const illinoisCountiesPopupTemplate = {
  // autocasts as new PopupTemplate()
  title: "Illinois County",
  expressionInfos: illinoisCountiesArcadeExpressionInfos,
  content: [
    {
      type: "fields",
      fieldInfos: [
        {
          fieldName: "expression/county-name"
        },
        {
          fieldName: "STATE_CODE",
          label: "State Code"
        },
        {
          fieldName: "TOTALPOP",
          label: "Population",
          format: {
            places: 0,
            digitSeparator: true
          }
        }
      ]
    }
  ]
};

export const illinoisCounties = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: true,
  sublayers: [
    {
      id: layerSource.IllinoisCountiesLayer,
      popupEnabled:false,
      popupTemplate: illinoisCountiesPopupTemplate
    }
  ]
});

export const idotDistrictsLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.IDOTDistrictsLayer
    }
  ]
});

export const usCongressBoundariesLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.USCongressBoundariesLayer
    }
  ]
});


export const ilHouseBoundariesLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.IlHouseBoundariesLayer
    }
  ]
});

export const ilSenateBoundariesLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.ILSenateBoundariesLayer
    }
  ]
});

export const politicalTownshipsLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 3300000,
  sublayers: [
    {
      id: layerSource.PoliticalTownshipsLayer
    }
  ]
});

export const urbanAreasLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.UrbanAreasLayer
    }
  ]
});

export const mpoAreasLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.MPOAreasLayer
    }
  ]
});

export const illinoisTownsArcadeExpressionInfos = [
  {
    name: "town-name",
    title: "Town Name",
    expression: "Proper($feature.IDOT_NAME)"
  }
];

export const illinoisTownsPopupTemplate = {
  // autocasts as new PopupTemplate()
  title: "Illinois Town",
  expressionInfos: illinoisTownsArcadeExpressionInfos,
  content: [
    {
      type: "fields",
      fieldInfos: [
        {
          fieldName: "expression/town-name"
        },
        {
          fieldName: "IDOT_MUNI",
          label: "Munincipality Code"
        },
        {
          fieldName: "POPULATION",
          label: "Population",
          format: {
            places: 0,
            digitSeparator: true
          }
        },
        {
          fieldName: "Shape.STArea()",
          label: "Area",
          format: {
            places: 0,
            digitSeparator: true
          }
        }
      ]
    }
  ]
};

export const illinoisTownsLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 400000,
  sublayers: [
    {
      id: layerSource.IllinoisTownsLayer,
      popupTemplate: illinoisTownsPopupTemplate
    }
  ]
});

export const boundaryLayersGroupLayer = new GroupLayer({
  title: "Boundary Layers",
  id: "11 - Boundary Layers",
  visible: true,
  visibilityMode: "independent",
  layers: [
    illinoisTownsLayer,
    mpoAreasLayer,
    urbanAreasLayer,
    illinoisCounties,
    politicalTownshipsLayer,
    ilSenateBoundariesLayer,
    ilHouseBoundariesLayer,
    usCongressBoundariesLayer,
    idotDistrictsLayer
  ]
});

boundaryLayersGroupLayer.layers.forEach(layer => {
  watchUtils.whenTrueOnce(layer, "loaded", () => {
    if (layer instanceof MapImageLayer) {
      layer.loadAll().then(() => {
        if (layer.sublayers.length === 1) {
          layer.title = layer.sublayers.getItemAt(0).sourceJSON.name;
          layer.sublayers.getItemAt(0).title = layer.sublayers.getItemAt(0).sourceJSON.name;
        }
        BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);
      });
    }
  });
});
